/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const TaskReferenceFragment = `
    fragment TaskReferenceFragment on Reference {
  _id
  type
  display
  reference
  active
}
    `
export const TaskAnnotationFragment = `
    fragment TaskAnnotationFragment on Annotation {
  authorReference {
    ...TaskReferenceFragment
  }
  time
  text
}
    `
export const TaskFragment = `
    fragment TaskFragment on Task {
  _id
  type
  status
  patientId
  patient {
    id
    display
    mrn
    nextgenId
    lumaId
  }
  patientPreferences
  treatmentId
  description
  dueDate
  comments {
    ...TaskAnnotationFragment
  }
  referralSource
  serviceType
  assignee {
    ...TaskReferenceFragment
  }
  createdBy {
    ...TaskReferenceFragment
  }
  createdDate
  lastUpdatedDate
}
    `
export const SearchableReferenceFragment = `
    fragment SearchableReferenceFragment on SearchableReference {
  id
  display
  reference
  active
}
    `
export const SearchableTaskFragment = `
    fragment SearchableTaskFragment on SearchableTask {
  id
  type
  status
  patient {
    id
    display
    mrn
    lumaId
    nextgenId
  }
  patientPreferences
  treatmentId
  description
  dueDate
  referralSource
  serviceType
  assignee {
    ...SearchableReferenceFragment
  }
  createdBy {
    ...SearchableReferenceFragment
  }
  createdDate
  lastUpdatedDate
  recentComments {
    text
    time
  }
}
    `
export const CreateTaskDocument = `
    mutation createTask($content: CreateTaskInput!) {
  createTask(content: $content) {
    ...TaskFragment
  }
}
    ${TaskFragment}
${TaskAnnotationFragment}
${TaskReferenceFragment}`
export const UpdateTaskDocument = `
    mutation updateTask($content: UpdateTaskInputV2!) {
  updateTaskV2(content: $content) {
    ...TaskFragment
  }
}
    ${TaskFragment}
${TaskAnnotationFragment}
${TaskReferenceFragment}`
export const UpdateTasksDocument = `
    mutation updateTasks($content: [UpdateTaskInputV2!]!) {
  updateTasks(content: $content) {
    ...TaskFragment
  }
}
    ${TaskFragment}
${TaskAnnotationFragment}
${TaskReferenceFragment}`
export const DeleteTaskDocument = `
    mutation deleteTask($_id: ID!) {
  deleteTask(_id: $_id) {
    ...TaskFragment
  }
}
    ${TaskFragment}
${TaskAnnotationFragment}
${TaskReferenceFragment}`
export const GetTasksByTreatmentIdDocument = `
    query getTasksByTreatmentId($treatmentId: ID!) {
  getTasksByTreatmentIds(treatmentIds: [$treatmentId]) {
    ...TaskFragment
  }
}
    ${TaskFragment}
${TaskAnnotationFragment}
${TaskReferenceFragment}`
export const GetTasksDocument = `
    query getTasks {
  getTasks {
    ...TaskFragment
  }
}
    ${TaskFragment}
${TaskAnnotationFragment}
${TaskReferenceFragment}`
export const GetTaskDocument = `
    query getTask($_id: ID!) {
  getTask(_id: $_id) {
    ...TaskFragment
  }
}
    ${TaskFragment}
${TaskAnnotationFragment}
${TaskReferenceFragment}`
export const SearchTasksDocument = `
    query searchTasks($query: AWSJSON!, $sort: AWSJSON, $pageSize: Int, $from: Int, $searchAfter: AWSJSON, $aggregations: AWSJSON) {
  searchTasks(
    query: $query
    sort: $sort
    pageSize: $pageSize
    from: $from
    searchAfter: $searchAfter
    aggregations: $aggregations
  ) {
    tasks {
      ...SearchableTaskFragment
    }
    resultCount
    from
    searchAfter
    aggregations
  }
}
    ${SearchableTaskFragment}
${SearchableReferenceFragment}`
export const GetOutstandingTasksDocument = `
    query getOutstandingTasks($query: AWSJSON!, $pageSize: Int) {
  searchTasks(query: $query, pageSize: $pageSize) {
    tasks {
      ...SearchableTaskFragment
    }
    resultCount
    from
    searchAfter
    aggregations
  }
}
    ${SearchableTaskFragment}
${SearchableReferenceFragment}`
export const GetSearchTasksAggregatesDocument = `
    query getSearchTasksAggregates($query: AWSJSON!, $aggregations: AWSJSON!) {
  searchTasks(query: $query, aggregations: $aggregations) {
    aggregations
  }
}
    `

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createTask: build.mutation<Types.CreateTask, Types.CreateTaskVariables>({
      query: (variables) => ({ document: CreateTaskDocument, variables }),
    }),
    updateTask: build.mutation<Types.UpdateTask, Types.UpdateTaskVariables>({
      query: (variables) => ({ document: UpdateTaskDocument, variables }),
    }),
    updateTasks: build.mutation<Types.UpdateTasks, Types.UpdateTasksVariables>({
      query: (variables) => ({ document: UpdateTasksDocument, variables }),
    }),
    deleteTask: build.mutation<Types.DeleteTask, Types.DeleteTaskVariables>({
      query: (variables) => ({ document: DeleteTaskDocument, variables }),
    }),
    getTasksByTreatmentId: build.query<
      Types.GetTasksByTreatmentId,
      Types.GetTasksByTreatmentIdVariables
    >({
      query: (variables) => ({
        document: GetTasksByTreatmentIdDocument,
        variables,
      }),
    }),
    getTasks: build.query<Types.GetTasks, Types.GetTasksVariables | void>({
      query: (variables) => ({ document: GetTasksDocument, variables }),
    }),
    getTask: build.query<Types.GetTask, Types.GetTaskVariables>({
      query: (variables) => ({ document: GetTaskDocument, variables }),
    }),
    searchTasks: build.query<Types.SearchTasks, Types.SearchTasksVariables>({
      query: (variables) => ({ document: SearchTasksDocument, variables }),
    }),
    getOutstandingTasks: build.query<
      Types.GetOutstandingTasks,
      Types.GetOutstandingTasksVariables
    >({
      query: (variables) => ({
        document: GetOutstandingTasksDocument,
        variables,
      }),
    }),
    getSearchTasksAggregates: build.query<
      Types.GetSearchTasksAggregates,
      Types.GetSearchTasksAggregatesVariables
    >({
      query: (variables) => ({
        document: GetSearchTasksAggregatesDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
